<template>
    <div>
        <div class="card-header">
            <h3>{{ $t("lang.label_mn_wget") }}</h3>
        </div>
        <div class="card-body" style="min-height: 200px">
            <div class="bgloading" v-show="isLoading"><Loader></Loader></div>
            <div class="row" v-if="isCode">
                <table width="100%" border="0">
                    <tr>
                        <td width="10px"></td>
                        <td>
                            {{ $t("lang.label_sw_info_spcl") }}
                            <div class="onoffswitch">
                                <input
                                    type="checkbox"
                                    :id="'cat' + 1"
                                    v-model="infoSpcl"
                                    class="onoffswitch-checkbox"
                                />
                                <label class="onoffswitch-label" :for="'cat' + 1">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </td>
                        <td></td>
                        <td>
                            {{ $t("lang.label_sw_info_res") }}
                            <div class="onoffswitch">
                                <input
                                    type="checkbox"
                                    :id="'cat' + 2"
                                    v-model="infoRes"
                                    class="onoffswitch-checkbox"
                                />
                                <label class="onoffswitch-label" :for="'cat' + 2">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </td>
                    </tr>
                </table>
                <div class="col-sm-12">
                    <!-- <textarea id="codeHtml"  style="height: 200px;width:100%;display:block;" readonly onClick="this.select()">&#60;div id="appMenu"&#62;&#60;/div&#62;&#60;script id="appScriptMenu"&#62;var d=document,appMenu={{ org_id }},IdDiv="appMenu",IdMenu="widgetMenu",f=new Date,urlMenu="{{url}}api/widget/appw1/",t=d.querySelector("#appScriptMenu"),s=d.createElement("script");s.type="text/javascript",s.id="widgetMenuScript",s.defer=!0,s.src=urlMenu+appMenu+"/"+f.getTime(),t.parentNode.insertBefore(s,t);&#60;/script&#62;</textarea> -->
                    <textarea
                        id="codeHtml"
                        style="height: 200px; width: 100%; display: block"
                        readonly
                        onClick="this.select()"
                        v-model="uriOrigin"
                    ></textarea>
                </div>
                <div class="col-12">
                    <button class="btn btn-primary" @click="copyhtml">
                        {{ $t("lang.label_cc") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
export default {
    name: "widgetTwo",
    components: {
        Loader,
    },
    data() {
        return {
            url: window.urlmaster,
            org_id: window.localuserdata,
            isLoading: false,
            isCode: true,
            infoSpcl: false,
            infoRes: false,
            uriOrigin:
                '<div id="appMenu"></div><script id="appScriptMenu">var d=document,appMenu=' +
                window.localuserdata +
                ',IdDiv="appMenu",IdMenu="widgetMenu",f=new Date,urlMenu="' +
                window.urlmaster +
                // eslint-disable-next-line no-useless-escape
                'api/widget/appw3/",t=d.querySelector("#appScriptMenu"),s=d.createElement("script");s.type="text/javascript",s.id="widgetMenuScript",s.defer=!0,s.src=urlMenu+appMenu+"/"+f.getTime(),t.parentNode.insertBefore(s,t);<\/script>',
        };
    },
    methods: {
        copyhtml() {
            var element = document.querySelector("#codeHtml").select();
            try {
                document.execCommand("copy");
                this.$swal({
                    type: "success",
                    title: window.lang2.msj_ccd,
                    timer: 1000,
                });
            } catch (err) {
                console.log("unable to copy code");
            }
        },
    },
    watch: {
        infoSpcl: {
            handler: function (val, oldVal) {
                var t = "";
                t += '<div id="appMenu"></div><script id="appScriptMenu">';
                t +=
                    "var d=document,appMenu=" +
                    window.localuserdata +
                    ',IdDiv="appMenu",';
                t +=
                    'IdMenu="widgetMenu",f=new Date,urlMenu="' +
                    window.urlmaster +
                    "api/widget/";                   
                if (this.infoSpcl === true && this.infoRes === false) {
                    t += 'appsw3/on/off/",';
                } else if (this.infoSpcl === false && this.infoRes === true) {
                    t += 'appsw3/off/on/",';
                } else if (this.infoSpcl === true && this.infoRes === true) {
                    t += 'appsw3/on/on/",';
                } else if (this.infoSpcl === false && this.infoRes === false) {
                    t += 'appw3/",';
                }
                t += 't=d.querySelector("#appScriptMenu"),s=d.createElement("script");';
                t += 's.type="text/javascript",s.id="widgetMenuScript",';
                t += 's.defer=!0,s.src=urlMenu+appMenu+"/"+f.getTime(),';
                // eslint-disable-next-line no-useless-escape
                t += "t.parentNode.insertBefore(s,t);<\/script>";
                this.uriOrigin = t;
            },
            deep: true,
        },
        infoRes: {
            handler: function (val, oldVal) {
                var t = "";
                t += '<div id="appMenu"></div><script id="appScriptMenu">';
                t +=
                    "var d=document,appMenu=" +
                    window.localuserdata +
                    ',IdDiv="appMenu",';
                t +=
                    'IdMenu="widgetMenu",f=new Date,urlMenu="' +
                    window.urlmaster +
                    "api/widget/";                  
                if (this.infoSpcl === true && this.infoRes === false) {
                    t += 'appsw3/on/off/",';
                } else if (this.infoSpcl === false && this.infoRes === true) {
                    t += 'appsw3/off/on/",';
                } else if (this.infoSpcl === true && this.infoRes === true) {
                    t += 'appsw3/on/on/",';
                } else if (this.infoSpcl === false && this.infoRes === false) {
                    t += 'appw3/",';
                }
                t += 't=d.querySelector("#appScriptMenu"),s=d.createElement("script");';
                t += 's.type="text/javascript",s.id="widgetMenuScript",';
                t += 's.defer=!0,s.src=urlMenu+appMenu+"/"+f.getTime(),';
                // eslint-disable-next-line no-useless-escape
                t += "t.parentNode.insertBefore(s,t);<\/script>";
                this.uriOrigin = t;
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.btn-switch {
    display: block;
    margin-top: 3%;
    margin-right: 30%;
    margin-left: 30%;
}
.onoffswitch {
    position: relative;
    // width: 60px;
    width: 95px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #585858;
    border-radius: 20px;
}
.onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.1s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 20px;
    padding: 0;
    line-height: 20px;
    font-size: 12px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "Encendido";
    padding-right: 10px;
    padding-left: 10px;
    background-color: #585858;
    color: #ffffff;
}
.onoffswitch-inner:after {
    content: "Apagado";
    padding-right: 10px;
    background-color: #d65353;
    color: #fff;
    text-align: right;
}
.onoffswitch-switch {
    display: block;
    width: 15px;
    height: 15px;
    margin: 6px;
    background: #fff;
    position: absolute;
    top: -3px;
    bottom: 0;
    // right: 33px;
    right: inherit;
    border: 1px solid #585858;
    border-radius: 20px;
    transition: all 0.1s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
</style>
